export default "__VITE_ASSET__1Oi8M0YF__"